export default function Contact() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-600 via-primary-700 to-foreground-900 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-primary-400/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-white/15 text-white text-xs font-semibold px-3 py-1.5 rounded-full mb-4 whitespace-nowrap">
                <i className="ri-mail-send-line"></i>
                <span>投稿爆料通道</span>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">有猛料？快来投稿</h2>
              <p className="mt-3 text-white/80 text-sm md:text-base leading-relaxed max-w-lg">
                如果你有网红相关的独家爆料、实锤证据或内幕消息，欢迎通过以下方式联系我们。投稿人信息将严格保密，核实后第一时间发布。
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-6">
                <div className="flex items-center gap-2 text-white/90 text-sm">
                  <i className="ri-mail-line text-lg"></i>
                  <span>tips@wanghongheiliao.com</span>
                </div>
                <div className="flex items-center gap-2 text-white/90 text-sm">
                  <i className="ri-shield-check-line text-lg"></i>
                  <span>严格保护投稿人隐私</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <a
                href="#"
                className="inline-flex items-center gap-2 bg-white text-primary-700 font-semibold text-sm px-8 py-4 rounded-xl hover:bg-accent-50 transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-black/20"
              >
                <i className="ri-send-plane-fill text-lg"></i>
                立即投稿
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}